<template>
  <v-footer app>
    <span v-if="$vuetify.breakpoint.smAndUp" class="caption"
      >&copy; 2026 Avtala Sverige AB</span
    >
    <a
      href="https://avtala.se/docs/index.html#user-agreement"
      target="_blank"
      class="ml-5 caption grey--text text-decoration-none"
    >
      Användarvillkor
    </a>
    <a
      v-if="$vuetify.breakpoint.smAndUp"
      href="https://avtala.se/docs/index.html#privacy-policy"
      target="_blank"
      class="ml-5 caption grey--text text-decoration-none"
    >
      Personuppgiftspolicy
    </a>
    <slot></slot>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
